import { FieldType } from '@wix/wix-data-schema-types';
const { text, boolean, number, dateTime, date, richText, url, reference, stringArray, } = FieldType;
const supportedAutomationFieldsTypes = [
    text,
    richText,
    boolean,
    dateTime,
    date,
    reference,
    number,
    url,
    stringArray,
];
export const isFieldSupported = (fieldData, fieldName) => {
    const supportedSystemFieldsNames = [
        '_id',
        '_owner',
        '_createdDate',
        '_updatedDate',
    ];
    const { type, systemField } = fieldData;
    const isSupportedType = supportedAutomationFieldsTypes.includes(type);
    const isSystemField = !!systemField;
    const isSupportedSystemField = supportedSystemFieldsNames.includes(fieldName);
    return isSupportedType && (!isSystemField || isSupportedSystemField);
};
//# sourceMappingURL=isFieldSupported.js.map